<template>
  <div id="tax-form"  class="listStyle">
    <div id="goToHere2"></div>
    <!-- 搜索框 -->
      <SearchBox
        ref="searchBox"
        @searchKeyWord="searchKeyWord"
        @selectTime="selectTime"
        @clearTime="clearTime"
        placehold="涉税表单查询">
      </SearchBox>
      <!-- 列表组件 -->
      <list-content
        ref="listContent"
        :lists="lists"
        :total="total"
        :totalLists="totalLists"
      ></list-content>
       <div v-if="lists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :totalLists="totalLists"
        @prevPage="prevPage"
        @nextPage="nextPage"
        @jumpToPageSize="jumpToPageSize"
      ></Pagination>
    </div>
      <van-overlay :showLoding="showLoding"></van-overlay>
  </div>
</template>

<script>
import SearchBox from "@/components/common/search";
import ListContent from "@/components/common/listContent";
import Pagination from "@/components/common/pagination"; // 分页
export default {
   data() {
    return {
      stime: '', // 开始时间
      etime: '', // 结束时间
      currentPage: 1, // 全国当前页数
      searchText: '', // 搜索文本
      showLoding: false,
      total: 0,
      totalLists: 0, // 总的条数
      lists: [],
      searchTimes: 1, // 查询次数
    }
  },
  components: {
    SearchBox,
    ListContent,
    Pagination
  },
  computed: {
    valueP() {
      return this.$store.state.commonSearchData.valueP;
    },
    valueC() {
      return this.$store.state.commonSearchData.valueC;
    },
    valueProvCode() {
      return this.$store.state.commonSearchData.valueProvCode;
    },
    valueCityCode() {
      return this.$store.state.commonSearchData.valueCityCode;
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 选择时间
    selectTime(time) {
      this.searchTimes = 1;
      console.log('222', time)
      this.stime = time.stime;
      this.etime = time.etime;
      this.currentPage = 1;
      this.getData();
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 搜索按钮
    searchKeyWord(keyword) {
      console.log('111', keyword)
      this.searchTimes = 1;
      //this.isFilter = false;
      this.searchText = keyword;
      this.currentPage = 1;
      this.backStatus();
      this.getData();
      this.$refs.listContent.toggle([]);
    },
    // 清除时间按钮
    clearTime() {
      this.searchTimes = 1;
      this.stime = '';
      this.etime = '';
      this.currentPage = 1;
      this.getData();
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
     // 恢复选择的状态
    backStatus() {
      this.$store.commit("choose/setFlag1", false);
    },
     // 点击上一页
    prevPage() {
      if (this.currentPage == 1) return;
      this.currentPage--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    },
    // 点击下一页
    nextPage() {
      if (this.currentPage == this.total) return;
      this.currentPage++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    },
    jumpToPageSize(num) {
      this.currentPage = num;
      this.$nextTick(()=> {
        let dom = document.getElementById("goToHere2")
        dom.scrollIntoView()
      });
      this.getData()
    },
    // 获取/请求地方版默认数据
    getData() {
      this.showLoding = true;
      let args = {
        searchtimes: this.searchTimes,
        frist: {
          text: this.searchText && this.searchText !== "" ? this.searchText : "",
          potence: "",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode
          },
          dirid: "",
          id: "",
          stime: this.stime && this.stime !== "" ? this.stime : "",
          etime: this.etime && this.etime !== "" ? this.etime : "",
          court: "",
          courttype: 0
        },
        second: [],
        fliter: {
          isfilter: false,
          tagpc: [],
          tagid: "",
        },
        pager: [
          {
            pagesize: 10, // 每页显示的条数
            pageindex: this.currentPage, // 当前页
          },
        ],
        scencs: "download"
      };
      let nodes = this.$baseConfig.code;
      this.$http
        .reqGetGeneralFiles(args, nodes)
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              console.log("taxForm2....", res);
              this.showLoding = false;
               this.lists =
                res.tbls[0].items !== null ? res.tbls[0].items : [];

              this.total = Math.ceil(res.tbls[0].total / 10);
              this.totalLists = res.tbls[0].total; // 总的条数

              this.$store.commit(
                "search/setIsProtect",
                res.tbls[0].protect
              );
              this.$store.commit(
                "search/setWarningLevel",
                res.tbls[0].warninglevel
              );
              this.$store.commit(
                "search/setWarningText",
                res.tbls[0].warningtext
              );

              this.$store.dispatch("choose/updateLists", this.lists);
            } else {
              warningNotify(res.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(res.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch(() => {
          this.showLoding = false;
        });
    }
  }

}
</script>

<style lang="less" scoped>
#tax-form {
   height:calc(100vh - 115px);
  overflow-y: auto;
  .pageBoxStyle {
    width: 100%;
    position: fixed;
    bottom:2px;
    left: 0;
    font-size: 0.37333rem;
    flex: 0 0 50px;
    background-color: #fff;
  }
}
</style>